import { useQuery } from "@tanstack/react-query";
import { apiCall } from "../lib/apiClient";

/**
 * Admin lookup uživatele + jeho nedávných akcí v audit logu.
 * Audit-log endpoint vrací jen základní pole — pro v1 stačí filtrovat klient-side
 * podle známých akcí, které mají v payloadu user_id (login, consent atd.).
 */

export interface UserDetailDto {
  user_id: string;
  tenant_id: string;
  email: string;
  display_name: string;
  role: string;
  push_assist_mode: boolean;
  consent_status: string;
  consent_text_version: string | null;
  failed_login_count: number;
  locked_until: string | null;
  first_login_at: string | null;
  created_at: string;
  deactivated_at: string | null;
}

export interface AuditLogEntry {
  id: string;
  tenantId: string | null;
  action: string;
  createdAt: string;
}

export function useUserDetail(userId: string | undefined) {
  return useQuery({
    queryKey: ["admin", "users", "detail", userId ?? "—"],
    queryFn: () => apiCall<UserDetailDto>(`/api/admin/users/${userId}`),
    enabled: typeof userId === "string" && userId.length > 0,
  });
}

/**
 * Vrátí posledních 50 entries audit logu napříč tenanty. Filtr per userId není
 * v MVP backendu — audit-log endpoint neexponuje payload pole. Stránka volajícího
 * tabulku filtruje po tenant_id (úspěšné login/logout entries mají tenant_id usera,
 * takže to slouží jako proxy).
 */
export function useAuditLogRecent() {
  return useQuery({
    queryKey: ["admin", "audit-log", "recent"],
    queryFn: () => apiCall<AuditLogEntry[]>("/api/admin/audit-log"),
  });
}
